export const setStartedWithOfferCode = (startedWithOfferCode) => ({
    type: "SET_STARTED_WITH_OFFERCODE", 
    startedWithOfferCode
});

export const SetOfferCode = (offerCode) => ({
    type: "SET_OFFERCODE", 
    offerCode
});


// WEBPACK FOOTER //
// ./src/actions/offerCodeAction.js